declare global {
  interface Window {
    /** Set by index.html before any third-party script; fixed for this document's lifetime. */
    __outlookPrivacyMode?: boolean
    __paxtonWebDocument?: boolean
  }
}

export function isOutlookPrivacyMode(): boolean {
  return window.__outlookPrivacyMode === true
}

/** A source opened in another Paxton tab must keep the parent document's privacy boundary. */
export function inheritOutlookPrivacyMode(target: string): string {
  if (!isOutlookPrivacyMode()) return target
  const url = new URL(target, window.location.href)
  if (url.origin !== window.location.origin) return target
  url.searchParams.set('outlook', '1')
  return url.toString()
}

/** Never expose an Outlook transcript to vendors already running in an ordinary web document. */
export function ensureOutlookPrivacyMode(originSurface: string | undefined): boolean {
  if (originSurface !== 'outlook' || isOutlookPrivacyMode()) return true
  const url = new URL(window.location.href)
  url.searchParams.set('outlook', '1')
  window.location.replace(url.toString())
  return false
}
